module.exports = __webpack_public_path__ + "img/gotpressure-min.deec3b19.jpg";